import { NgModule } from '@angular/core';
import { Routes, RouterModule, mapToCanActivate } from '@angular/router';

import { LunaClaimValues } from "../models/user-identity.model";
import { BaseGuardService } from "../auth/guards/base-guard.service";
import { SystemPermissionGuardService } from "../auth/guards/system-permission-guard.service";
import { InternalGuardService } from "../auth/guards/internal-guard.service";

import { OnBehalfWrapperComponent } from "./components/on-behalf-wrapper/on-behalf-wrapper.component";

const routeGuards = [BaseGuardService, SystemPermissionGuardService];
const internalGuards = [BaseGuardService, InternalGuardService, SystemPermissionGuardService];

export const ON_BEHALF_ROUTES: Routes = [
    {
        path: "",
        data: { permission: LunaClaimValues.ExecuteFlowOnBehalf },
        component: OnBehalfWrapperComponent,
        canActivate: mapToCanActivate(internalGuards),
        children: []
    }
]

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OnBehalfRoutingModule { }
